// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d27590be","239":"a59e35e6","732":"cd450c5e"}[chunkId] + ".chunk.js";
};